<template>
    <div v-separator-link="200" slot="content">
        <div class="gcmcn-form-title">{{ ird ? 'Edit' : 'Add'}} automatic receiver </div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form" @validate="inputIsvalidated">
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="name">
                            <div class="gcmcn-form-label">Automatic receiver name</div>
                            <el-input
                                size="mini"
                                v-model="form.name"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-5">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="entity_uid"
                        >
                            <div class="gcmcn-form-label">Entity</div>
                            <el-select
                                v-model="form.entity_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder=""
                            >
                                <el-option
                                    v-for="entity in availableEntities"
                                    :key="entity.uid"
                                    :label="entity.display_name"
                                    :value="entity.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="taker_uid"
                        >
                            <div class="gcmcn-form-label">Taker</div>
                            <el-select
                                v-model="form.taker_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                :disabled="!this.form.entity_uid"
                            >
                                <el-option
                                    v-for="taker in availableTakers"
                                    :key="taker.uid"
                                    :label="taker.name"
                                    :value="taker.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="hw_type_uid"
                        >
                            <div class="gcmcn-form-label">Receiver hardware type</div>
                            <el-select
                                v-model="form.hw_type_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder=""
                            >
                                <el-option
                                    v-for="hwType in hwTypes"
                                    :key="hwType.uid"
                                    :label="hwType.name"
                                    :value="hwType.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item class="gcmcn-form-input">
                    <div class="gcmcn-form-label">Latency</div>
                    <el-select
                        v-model="form.latency"
                        size="mini"
                        popper-class="gcmcn-popper"
                    >
                        <el-option
                            v-for="lat in sortedLatencies"
                            :key="lat.uid"
                            :label="`${lat.value_ms} ms (${lat.name})`"
                            :value="lat.value_ms"
                        >
                        </el-option>
                        <el-option label="/" :value="0"></el-option">
                    </el-select>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input radio-input"
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin"
                >
                    <div class="gcmcn-form-label">Encryption</div>
                    <el-radio
                        v-model="form.decryption_type"
                        label="aes256"
                    >
                        aes256
                    </el-radio>
                    <el-radio
                        v-model="form.decryption_type"
                        label="aes128"
                    >
                        aes128
                    </el-radio>
                    <el-radio
                        v-model="form.decryption_type"
                        label=""
                    >
                        No encryption
                    </el-radio>
                </el-form-item>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <div class="gcmcn-form-label custom-label">Receiver public IPs (CIDR)</div>
                        <div
                            class="custom-input"
                            v-for="(ip, index) in form.public_ips"
                            :key="index"
                        >
                            <el-form-item
                                class="gcmcn-form-input"
                                :prop="`public_ips[${index}].value`"
                                :rules="{ validator: multipleValideIp }"
                                :inline-message="true"
                            >
                                <el-input
                                    size="mini"
                                    v-model="ip.value"
                                    :class="index === form.public_ips.length-1 && form.public_ips.length < 3?'add-ip-input':''"
                                >
                                </el-input>
                                <el-button
                                    v-if="form.public_ips.length !== 1"
                                    type="danger"
                                    class="gcmcn-danger-btn small"
                                    icon="el-icon-delete-solid"
                                    @click="removePublicIp(index)"
                                ></el-button>
                                <el-button
                                    v-if="index === form.public_ips.length-1 && form.public_ips.length < 3"
                                    type="primary"
                                    class="gcmcn-primary-btn small add-ip-button"
                                    @click="addPublicIp"
                                    :disabled="ip.value ==='' || disableAddIpButton"
                                >
                                    Add IP
                                </el-button>
                            </el-form-item>

                        </div>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="private_ip">
                            <div class="gcmcn-form-label">Receiver private IP (over VPN)</div>
                            <el-input
                                size="mini"
                                v-model="form.private_ip"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div v-if="getHardwareType === 'zixi'">
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="login">
                                <div class="gcmcn-form-label">Zixi receiver login</div>
                                <el-input
                                    size="mini"
                                    v-model="form.login"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="password">
                                <div class="gcmcn-form-label">Zixi receiver password</div>
                                <el-input
                                    size="mini"
                                    show-password
                                    v-model="form.password"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm">Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {

    components: {
    },

    props: {
        ird: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },

    data (){
        const valideIp = (rule, value, cb) => {
            const ipRegex = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
            if(!value){
                return cb(new Error('This field can\'t be empty'));
            }else if(!value.match(ipRegex)){
                return cb(new Error('Please input a valid ip'));
            }else{
                cb();
            }

        };
        return {
            isSrt: false,
            loading: false,
            disableAddIpButton: true,
            form: {
                name: '',
                taker_uid: '',
                entity_uid: '',
                hw_type_uid: '',
                private_ip: '',
                public_ips:[{value:''}],
                public_ip: '',
                login: '',
                password: '',
                latency: 0,
                decryption_type: 'aes256',
            },
            rules: {
                name: [{ required: true, validator: this.authorizedCharacters }],
                taker_uid: [{ required: true }],
                entity_uid: [{ required: true }],
                hw_type_uid: [{ required: true }],
                private_ip: [{ validator: valideIp }],
                login: [{ required: true }],
                password: [{ required: true }],

            },
        };
    },

    computed: {
        ...mapGetters([
            'hwTypesByUid',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'administrableEntitiesUids',
            'entities',
            'hwTypes',
            'sortedLatencies',
            'zixiReceivers',
            'takers',
            'authorizedCharactersRegex',
        ]),
        availableEntities(){
            if(this.userIsEntityAdmin()){
                return this.entities.filter(
                    entity => this.administrableEntitiesUids.includes(entity.uid)
                );
            }
            return this.entities;
        },
        relatedZixireceiver (){
            return this.zixiReceivers.find((zixi) => zixi.ird_uid === this.ird.uid);
        },

        availableTakers (){
            return this.takers.filter((taker) => {
                return taker.scopes.entity_uid === this.form.entity_uid;
            });
        },

        formTaker (){
            return this.takers.find((taker) => taker.uid === this.form.taker_uid);
        },
        getHardwareType() {
            if(this.form.hw_type_uid) {
                return this.hwTypesByUid(this.form.hw_type_uid).source_protocol_type;
            } else {
                return null;
            }
        },
    },

    watch: {
        ird: {
            handler (){
                if(!this.loading){
                    this.setForm();
                }
            },
            deep: true,
            immediate: true,
        },
        'form.entity_uid': function(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.form.taker_uid = '';
            }
        }
    },

    created (){
    },

    methods: {
        setForm (){
            if(this.ird){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.ird)));
                this.$set(this.form, 'login', this.relatedZixireceiver.login);
                this.$set(this.form, 'password', this.relatedZixireceiver.password);
                this.$set(this.form, 'entity_uid', this.ird.scopes.entity_uid);
                if(Object.keys(this.form.public_ips).length === 0){
                    this.form.public_ips = [];
                    if(this.form.public_ip !== ''){
                        this.form.public_ips.push({value: this.form.public_ip});
                        this.disableAddIpButton = false;
                    }else{
                        this.form.public_ips.push({value: ''});
                    }
                }else{
                    this.form.public_ips = this.setPublicIpsValue();
                    this.disableAddIpButton = false;
                }

            }else{
                this.$set(this, 'form', {
                    name: '',
                    taker_uid: '',
                    entity_uid: '',
                    hw_type_uid: '',
                    private_ip: '',
                    public_ip: '',
                    public_ips:[{value:''}],
                    login: '',
                    password: '',
                    latency: 0,
                    decryption_type: 'aes256',
                });
            }
        },
        authorizedCharacters(rules, value, callback) {
            if(!this.form.name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.name.match(this.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        addPublicIp(){
            this.form.public_ips.push({value: ''});
        },
        removePublicIp(index){
            this.form.public_ips.splice(index, 1);
        },
        inputIsvalidated(prop, valid){
            if(prop.includes('public_ips')){
                if(valid){
                    this.disableAddIpButton = false;
                }else{
                    this.disableAddIpButton = true;
                }
            }
        },
        multipleValideIp(rule, value, cb){
            const ipRegex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\/([0-9]|[1-2][0-9]|3[0-2])$/;
            if(!value){
                return cb(new Error('This field can\'t be empty'));
            }else if(!value.match(ipRegex)){
                return cb(new Error('Must be a valid ip with mask'));
            }else{
                cb();
            }
        },
        setPublicIpsField(){
            const ips = this.form.public_ips;
            let publicIpsField = [];
            for(let value in ips){
                publicIpsField.push(ips[value].value.trim());
            }
            return publicIpsField;
        },
        setPublicIpsValue(){
            const ips = this.form.public_ips;
            let publicIpsValue = [];
            for(let value in ips){
                publicIpsValue.push({value : ips[value]});
            }
            return publicIpsValue;
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    let messageType = this.ird ? 'update' : 'create';
                    if(this.formTaker.group_uid){
                        this.sendRequest(messageType);
                    } else {
                        let intervalId = setInterval(() => {
                            /*
                                We reload fetch on model taker to get the formTaker.group_uid which
                                allow us to set the can_view_groups/can_admin_groups.
                            */
                            this.$store.dispatch('fetchModelByName', 'takers');
                            if(this.formTaker.group_uid){
                                clearInterval(intervalId);
                                this.sendRequest(messageType);
                            }
                        }, 5000);

                        // Stop loading and add notification after 10minutes.
                        setTimeout(() => {
                            clearInterval(intervalId);
                            this.$message.error(`Error on automatic receiver ${messageType === 'update' ? messageType : 'creation'}.`);
                        }, 600000);
                    }
                }
            });
        },
        sendRequest(messageType){
            let form = JSON.parse(JSON.stringify(this.form));
            let action;
            let postData = { item: form, model: 'irds'};
            postData.item['remote_id'] = 'retrieving...';

            postData.item.public_ips = this.setPublicIpsField();
            postData.item.public_ip = postData.item.public_ips[0];
            let zixireceiverForm = {
                status: 'PENDING',
                login: form.login,
                password: form.password,
                can_view_groups: [this.formTaker.group_uid],
                can_admin_groups: [this.formTaker.group_uid],
            };
            let zixiReceiverPostData = { item: zixireceiverForm, model: 'zixiReceivers'};
            form.region_uid = this.formTaker.aws_region;
            form.can_view_groups = [this.formTaker.group_uid];
            form.can_admin_groups = [this.formTaker.group_uid];
            if(this.ird){
                action = 'patchItem';
                form.url = this.ird.url;
                zixireceiverForm.url = this.relatedZixireceiver.url;
            }else{
                action = 'createItem';
                postData.url = this.$store.state.api.meta.listModels.irds.url;
                postData.scopes = {'X-Entity-Uid': form.entity_uid};
                zixiReceiverPostData.url = this.$store.state.api.meta.listModels.zixiReceivers.url;
                zixiReceiverPostData.scopes = {'X-Entity-Uid':  form.entity_uid };
            }
            this.$store.dispatch(action, postData).then((res) => {
                zixireceiverForm.ird_uid = res.uid;
                this.$store.dispatch(action, zixiReceiverPostData).then(() => {
                    this.$message({
                        message: `Automatic receiver ${messageType}d!`,
                        type: 'success'
                    });
                    this.loading = false;
                    this.leave();
                }).catch((e) => {
                    throw e;
                });
            }).catch(() => {
                this.loading = false;
                this.$message.error(`Error on automatic receiver ${messageType === 'update' ? messageType : 'creation'}.`);
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

.el-form-item__error--inline{
    display: block;
    margin-left: 0;
    margin-bottom: 10px;
}
.custom-label{
    font-family: roboto-light;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 5px !important;
}
.custom-input {
    .gcmcn-form-input{
        margin-bottom: 10px !important;
        .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            .el-input{
                width: 70%;
                margin-right: 1rem;
            }
            .el-button{
                width: 53px;
                i{
                    margin-right: 0 !important;
                }
            }
            .el-form-item__error--inline{
                display: block;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Ird/irdForm.vue